import { Component, OnInit } from '@angular/core';
import { RegistrationFormField } from 'interfaces/registration-form-field.interface';
import { ActivatedRoute, Router } from '@angular/router';
import { getSection } from 'utils/helpers';
import { Store } from '@ngrx/store';
import { Selectors } from 'features/profiles-state/+state/profiles-state.state';
import { map } from 'rxjs/operators';
import { ROLE_CODES } from 'constants/role.constants';
import { STEP_TYPE_STATUSES, STEP_TYPES } from 'constants/status.constants';
import { Observable } from 'rxjs';
import { constants } from 'constants/constants';
import { FIELDS_NAMES } from 'constants/registration-form.constants';
import { ComputedFrom } from '@certemy/common';

export function covertToRegistrationFieldsToPreview(registrationFormFields) {
  return registrationFormFields
    .filter(field => field.name !== FIELDS_NAMES.ada)
    .map(field => {
      if (field.value && !!field.options && field.options.length) {
        if (field.type_id === constants.FORM_FIELD_TYPE_IDS.CHECKBOX) {
          field.value = field.options
            .map(option => (field.value[option.id] ? option.name : ''))
            .filter(name => name)
            .join(', ');
        } else {
          const selectedOption = field.options.find(option => option.id === field.value);
          field.value = selectedOption.name;
        }
      }
      return field;
    });
}

@Component({
  selector: 'cm-registration-form-details-preview',
  templateUrl: './registration-form-details-preview.component.html',
  styleUrls: ['./registration-form-details-preview.component.scss'],
})
export class RegistrationFormDetailsPreviewComponent implements OnInit {
  registrationFormInfo;
  backUrl = '';
  isRegistrationFormEditable$: Observable<boolean>;
  TEST_REGISTRATION_STATUSES = constants.TEST_REGISTRATION_STATUSES;

  @ComputedFrom('registrationFormInfo')
  get registrationFormFields(): RegistrationFormField[] {
    return covertToRegistrationFieldsToPreview(this.registrationFormInfo.registration_form.fields);
  }

  constructor(private router: Router, private activatedRouter: ActivatedRoute, private store: Store<any>) {}

  ngOnInit() {
    this.registrationFormInfo = this.activatedRouter.snapshot.data.registrationFormInfo;
    const { profileId, certificateId, phaseId } = this.activatedRouter.snapshot.params;

    const registrationStep = this.activatedRouter.snapshot.data.stepsData.steps.find(
      step => step.step_type_id === STEP_TYPES.REGISTRATION_FORM,
    );

    this.backUrl = `/${getSection(
      window.location.pathname,
    )}/users/${profileId}/certifications/${certificateId}/phases/${phaseId}/steps`;

    this.isRegistrationFormEditable$ = this.store
      .select(Selectors.currentRoleId)
      .pipe(
        map(
          roleId =>
            roleId === ROLE_CODES.IMPOSER &&
            !this.registrationFormInfo.use_smt_option &&
            this.registrationFormInfo.test_instance_compliance_status_id !== this.TEST_REGISTRATION_STATUSES.COMPLETED,
        ),
      );
  }

  editRegistrationForm() {
    this.router.navigate(['./edit'], { relativeTo: this.activatedRouter });
  }
}
